import React, { FC } from 'react';
import BananatagButton from '../BananatagButton';
import * as Styled from './styles';

interface Props {
    isUploadComplete: boolean;
    close: () => void;
}
const FileStatusesResult: FC<Props> = ({ isUploadComplete, close }) => (
    <Styled.FileStatusesResult>
        {isUploadComplete ? <BananatagButton size="medium" text="done" onClick={close} /> : 'Please wait...'}
    </Styled.FileStatusesResult>
);
export default FileStatusesResult;
